import { Button, CircularProgress, PlusIcon, Text } from 'crunch-components';
import PropTypes from 'prop-types';

const FilterButton = ({ disabled, loading, onClick, noText }) => (
	<div className="inline-flex items-center">
		{!disabled && (
			<Button
				className="flex gap-2"
				type="button"
				size="regular"
				variant="link"
				onClick={onClick}
			>
				<PlusIcon className="w-3" />
				{!noText && (
					<Text size="text-sm" className="font-bold">
						Add filter
					</Text>
				)}
			</Button>
		)}
		{loading && <CircularProgress size="small" />}
	</div>
);

FilterButton.propTypes = {
	disabled: PropTypes.bool,
	loading: PropTypes.bool,
	onClick: PropTypes.func,
	noText: PropTypes.bool,
};

FilterButton.defaultProps = {
	disabled: false,
	loading: false,
	onClick: () => {},
	noText: false,
};

export default FilterButton;
